// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import IframeThemeController from "./iframe_theme_controller"
application.register("iframe-theme", IframeThemeController)

import MessageScrollerChatController from "./message_scroller_chat_controller"
application.register("message-scroller-chat", MessageScrollerChatController)

import RubyUi__AlertDialogController from "./ruby_ui/alert_dialog_controller"
application.register("ruby-ui--alert-dialog", RubyUi__AlertDialogController)

import RubyUi__AvatarController from "./ruby_ui/avatar_controller"
application.register("ruby-ui--avatar", RubyUi__AvatarController)

import RubyUi__ButtonController from "./ruby_ui/button_controller"
application.register("ruby-ui--button", RubyUi__ButtonController)

import RubyUi__CalendarController from "./ruby_ui/calendar_controller"
application.register("ruby-ui--calendar", RubyUi__CalendarController)

import RubyUi__CalendarInputController from "./ruby_ui/calendar_input_controller"
application.register("ruby-ui--calendar-input", RubyUi__CalendarInputController)

import RubyUi__CarouselController from "./ruby_ui/carousel_controller"
application.register("ruby-ui--carousel", RubyUi__CarouselController)

import RubyUi__ChartController from "./ruby_ui/chart_controller"
application.register("ruby-ui--chart", RubyUi__ChartController)

import RubyUi__CheckboxController from "./ruby_ui/checkbox_controller"
application.register("ruby-ui--checkbox", RubyUi__CheckboxController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__ClipboardController from "./ruby_ui/clipboard_controller"
application.register("ruby-ui--clipboard", RubyUi__ClipboardController)

import RubyUi__CodeblockController from "./ruby_ui/codeblock_controller"
application.register("ruby-ui--codeblock", RubyUi__CodeblockController)

import RubyUi__CollapsibleController from "./ruby_ui/collapsible_controller"
application.register("ruby-ui--collapsible", RubyUi__CollapsibleController)

import RubyUi__ComboboxController from "./ruby_ui/combobox_controller"
application.register("ruby-ui--combobox", RubyUi__ComboboxController)

import RubyUi__CommandController from "./ruby_ui/command_controller"
application.register("ruby-ui--command", RubyUi__CommandController)

import RubyUi__ContextMenuController from "./ruby_ui/context_menu_controller"
application.register("ruby-ui--context-menu", RubyUi__ContextMenuController)

import RubyUi__DataTableColumnVisibilityController from "./ruby_ui/data_table_column_visibility_controller"
application.register("ruby-ui--data-table-column-visibility", RubyUi__DataTableColumnVisibilityController)

import RubyUi__DataTableController from "./ruby_ui/data_table_controller"
application.register("ruby-ui--data-table", RubyUi__DataTableController)

import RubyUi__DataTableSearchController from "./ruby_ui/data_table_search_controller"
application.register("ruby-ui--data-table-search", RubyUi__DataTableSearchController)

import RubyUi__DatePickerController from "./ruby_ui/date_picker_controller"
application.register("ruby-ui--date-picker", RubyUi__DatePickerController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__DropdownMenuController from "./ruby_ui/dropdown_menu_controller"
application.register("ruby-ui--dropdown-menu", RubyUi__DropdownMenuController)

import RubyUi__FormController from "./ruby_ui/form_controller"
application.register("ruby-ui--form", RubyUi__FormController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__HoverCardController from "./ruby_ui/hover_card_controller"
application.register("ruby-ui--hover-card", RubyUi__HoverCardController)

import RubyUi__InputOtpController from "./ruby_ui/input_otp_controller"
application.register("ruby-ui--input-otp", RubyUi__InputOtpController)

import RubyUi__MaskedInputController from "./ruby_ui/masked_input_controller"
application.register("ruby-ui--masked-input", RubyUi__MaskedInputController)

import RubyUi__MessageScrollerController from "./ruby_ui/message_scroller_controller"
application.register("ruby-ui--message-scroller", RubyUi__MessageScrollerController)

import RubyUi__PopoverController from "./ruby_ui/popover_controller"
application.register("ruby-ui--popover", RubyUi__PopoverController)

import RubyUi__SelectController from "./ruby_ui/select_controller"
application.register("ruby-ui--select", RubyUi__SelectController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__SidebarController from "./ruby_ui/sidebar_controller"
application.register("ruby-ui--sidebar", RubyUi__SidebarController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__ThemeToggleController from "./ruby_ui/theme_toggle_controller"
application.register("ruby-ui--theme-toggle", RubyUi__ThemeToggleController)

import RubyUi__ToastController from "./ruby_ui/toast_controller"
application.register("ruby-ui--toast", RubyUi__ToastController)

import RubyUi__ToasterController from "./ruby_ui/toaster_controller"
application.register("ruby-ui--toaster", RubyUi__ToasterController)

import RubyUi__ToggleController from "./ruby_ui/toggle_controller"
application.register("ruby-ui--toggle", RubyUi__ToggleController)

import RubyUi__ToggleGroupController from "./ruby_ui/toggle_group_controller"
application.register("ruby-ui--toggle-group", RubyUi__ToggleGroupController)

import RubyUi__TooltipController from "./ruby_ui/tooltip_controller"
application.register("ruby-ui--tooltip", RubyUi__TooltipController)

import SidebarMenuController from "./sidebar_menu_controller"
application.register("sidebar-menu", SidebarMenuController)

import ToastDemoController from "./toast_demo_controller"
application.register("toast-demo", ToastDemoController)
